const customerNoteColor = '#04325B'
const deltekNoteColor = '#0098D6'
const deltekNoteHoverColor = '#0088D6'
const dialogActionHR = '#696969'
const internalNoteColor = '#AD0F0F'
const viewOnlyHeaderColor = '#3B3B3B'
const viewOnlyBorderColor = '#8B8B8B'
const viewOnlyBackgroundColor = '#5E5F61'
const hasUnreadNotesColor = '#10B091'

export default {
    customerNoteColor,
    deltekNoteColor,
    deltekNoteHoverColor,
    dialogActionHR,
    internalNoteColor,
    viewOnlyHeaderColor,
    viewOnlyBackgroundColor,
    viewOnlyBorderColor,
    hasUnreadNotesColor,
}
